// extracted by mini-css-extract-plugin
module.exports = {"badge":"TagsInput_badge__LudO1","inner":"TagsInput_inner__AmeVr","createOption":"TagsInput_createOption__mSx_r","dropdown":"TagsInput_dropdown__9xNYH"};